import { Asset } from '../types';

export function getAssetName(asset?: Asset | null): string {
  if (!asset) return '';
  if (asset.title) return asset.title;
  if (asset.name) return asset.name;
  if (asset.metaData) {
    try {
      const meta = JSON.parse(asset.metaData);
      return meta.name || meta.fileName || '';
    } catch {
      return '';
    }
  }
  return '';
}

export function getAssetType(asset?: Asset | null): string {
  if (!asset?.metaData) return '';
  try {
    const meta = JSON.parse(asset.metaData);
    const type = meta.type || '';
    if (type.includes('video')) return 'Video';
    if (type.includes('image')) return 'Image';
    if (type.includes('audio')) return 'Audio';
    return '';
  } catch {
    return '';
  }
}

export function getAssetSize(asset?: Asset | null): string {
  if (!asset?.metaData) return '';
  try {
    const meta = JSON.parse(asset.metaData);
    const size = meta.size;
    if (!size) return '';
    const mb = size / (1024 * 1024);
    if (mb >= 1) return `${mb.toFixed(1)} MB`;
    return `${(size / 1024).toFixed(0)} KB`;
  } catch {
    return '';
  }
}
